import axios from "axios";

axios.interceptors.response.use(
  response => response,
  error => {
    const errorInfo = error.response;
    let errorMsg: string;
    if (errorInfo.data.error.details) {
      errorMsg = errorInfo.data.error.details;
    } else if (errorInfo.data.error.message) {
      errorMsg = errorInfo.data.error.message;
    } else if (errorInfo.data.error_description) {
      errorMsg = errorInfo.data.error_description;
    } else {
      errorMsg = errorInfo.statusText;
    }
    console.log(errorMsg);
    error.errorMsg = errorMsg;
    return Promise.reject(error);
  }
);
